module.exports = __webpack_public_path__ + "img/Mage-undead-f-60.8df1b9f4.gif";